import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'

class InterceptorLogService {
  private endpoint = `${API_PATH_INTERNAL}/interceptor`

  async archive(id: number): Promise<void> {
    await apiService.patch(`${this.endpoint}/${id}/update`, {
      isArchived: true,
    })
  }

  async unarchive(id: number): Promise<void> {
    await apiService.patch(`${this.endpoint}/${id}/update`, {
      isArchived: false,
    })
  }

  async linkReferral(id: number, referralId: number): Promise<void> {
    await apiService.patch(`${this.endpoint}/${id}/update`, {
      referral: `${API_PATH_INTERNAL}/referrals/${referralId}`,
    })
  }
}

const interceptorLogService = new InterceptorLogService()

export default interceptorLogService
